export default __webpack_public_path__ + "static/media/doodle.cc88afc5.png";